import { THEME } from 'GlobalStyles';

export const AI_ASSISTANT_TYPOGRAPHY_STYLES = {
  fontSize: 16,
  lineHeight: 1.5,
  '& p, & li, & span, & div': {
    fontSize: 16
  },
  '& h1': {
    fontSize: 22,
    lineHeight: 1.5,
    marginTop: THEME.spacing(3)
  },
  '& h2': {
    fontSize: 20,
    lineHeight: 1.5,
    marginTop: THEME.spacing(2)
  },
  '& h3': {
    fontSize: 18,
    lineHeight: 1.5,
    marginTop: THEME.spacing(1.5)
  },
  '& h4, & h5, & h6': {
    fontSize: 16,
    lineHeight: 1.5,
    marginTop: THEME.spacing(1)
  },
  '& pre': {
    maxWidth: '100%',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowX: 'auto'
  },
  '& pre code': {
    whiteSpace: 'inherit',
    wordBreak: 'inherit'
  }
};
